/**
 * Third-party APIs through our own /api/proxy/<service>/<endpoint>, so their keys stay on the
 * server (Api::Proxy::UpstreamsController) instead of shipping in this bundle or the page.
 *
 * The proxy keeps each provider's request and response shape: callers build the same query
 * string they sent to the provider, minus the key.
 */
export const API_PROXY_PATH = '/api/proxy';

export type ApiProxyService = 'graphhopper' | 'stadia' | 'openweather' | 'what3words';

export function apiProxyUrl(service: ApiProxyService, endpoint: string, query: string): string {
  const q = query.replace(/^[?&]+/, '');
  return `${API_PROXY_PATH}/${service}/${endpoint}${q ? `?${q}` : ''}`;
}

export function graphhopperProxyUrl(endpoint: 'route' | 'match', query: string): string {
  return apiProxyUrl('graphhopper', endpoint, query);
}

/**
 * The page's CSRF token, which is how the proxy lets a logged-out visitor through to the
 * providers public pages use (routing, place search, weather). A signed-in visitor's session
 * cookie rides along same-origin and needs nothing extra.
 */
export function apiProxyHeaders(doc: Document | null = globalThis.document ?? null): Record<string, string> {
  const token = doc?.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
  return token ? { 'X-CSRF-Token': token } : {};
}
